import React, { Component } from 'react'

import Dico from '../../helpers/Dico';
import TextWithFieldname from '../texts/TextWithFieldname';
import ContDetailsButton from '../../containers/ContDetailsButton';
import ContFinanceFileButton from '../../containers/ContFinanceFileButton';
import ContMessageI18N from '../../containers/ContMessageI18N';
import ResultError from './ResultError';
import HelperTeaser from '../../helpers/HelperTeaser';
import HelperEnv from '../../helpers/HelperEnv';

class TeaserPres extends Component {

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }

	occRenvoiGlob = 0;
	render() {
		var developperView = this.props.settings.isDevelopperView;
		var amountNature = this.props?.teaser?.data?.renderAmountNature ?? "TC";
		var process = this.props.settings.process;
		const isFinanceFile = this.props.settings.isFinanceFile;
		this.occRenvoiGlob = this.props.occRenvoi - HelperTeaser.getNbOccRenvoi(this.props.teaser) + 1;
		return (
			<div>
				{this.props.teaser && this.props.teaser.data && this.props.teaser.data.noDeposit != null && this.props.teaser.data.noDeposit === true
					&& <span className='badge rounded-pill text-bg-secondary float-end'>{this.getMessage('generics.teaser.nodeposit')}</span>
				}
				{this.props.vehicle != null && this.props.vehicle.presentation != null &&
					<div>
						{this.props.vehicle.presentation.logo && this.props.vehicle.presentation.logo.trim() !== '' &&
							<img src={this.props.vehicle.presentation.logo} height="45" alt={this.props.vehicle.presentation.longLabel} />
						}
						<h6>
							{this.props.vehicle.presentation.longLabel}
						</h6>
					</div>
				}
				{developperView && this.props.teaser && this.props.teaser.data && this.props.teaser.data.financialProductLabel != null &&
					<TextWithFieldname fieldname="financialProductLabel" variant="h6" developperView={developperView}>
						{this.props.teaser.data.financialProductLabel}
					</TextWithFieldname>
				}
				{this.props.teaser && this.props.teaser.financialProductTitle != null &&
					<TextWithFieldname fieldname="financialProductTitle" variant="h6" developperView={developperView}>
						{Dico.getTextWithArguments(this.props.teaser.financialProductTitle,
							this.props.teaser.data,
							amountNature, this.props.context.countryCode, this.props.context.languageCode,
							this.props.teaser.guide)}
					</TextWithFieldname>
				}
				{this.props.teaser && this.props.teaser.data.financialOfferLabel != null &&
					<TextWithFieldname fieldname="financialOfferLabel" variant="h6" developperView={developperView}>
						{this.props.teaser.data.financialOfferLabel}
					</TextWithFieldname>
				}
				{this.props.teaser && this.props.teaser.regularPayment != null &&
					<TextWithFieldname fieldname="regularPayment" variant="h4" developperView={developperView}>
						{Dico.getTextWithArguments(this.props.teaser.regularPayment,
							this.props.teaser.data,
							amountNature, this.props.context.countryCode, this.props.context.languageCode,
							this.props.teaser.guide)}
						{this.props.teaser.textConditions != null && this.props.teaser.textConditions.regularPaymentConditions != null &&
							<React.Fragment > ({this.returnReference()})</React.Fragment>
						}
						{this.props.teaser.callToAction != null && this.props.teaser.callToAction.useDetail && !this.props.isDetail && <ContDetailsButton
							vehicleDetailsIn={this.props.vehicleDetails}
							vehicle={this.props.vehicle}
							configurationKey={this.props.vehicle && this.props.vehicle.configurationKey}
							detailLabel={this.props.teaser.callToAction.detailText}
							showCtaText={this.props.teaser.callToAction.showCtaText}
							useWidget={this.props.teaser.callToAction.useWidget}
							href={this.props.teaser.callToAction.href}
						/>}
						{this.props.vehicleDetails && HelperEnv.isAuthenticationSet(this.props.env) && isFinanceFile === true
							&& <ContFinanceFileButton />
						}
					</TextWithFieldname>
				}
				{this.props.teaser && this.props.teaser.primarytext != null &&
					<TextWithFieldname fieldname="primarytext" developperView={developperView} variant="fs-6">
						{this.props.teaser.primarytext.map((line, index) => (
							<span key={index} style={Dico.getStyle(line.style, false, true)}>
								{Dico.getTextWithArguments(line,
									this.props.teaser.data,
									amountNature, this.props.context.countryCode, this.props.context.languageCode,
									this.props.teaser.guide)}
								{index === this.props.teaser.primarytext.length - 1 &&
									this.props.teaser.textConditions != null && this.props.teaser.textConditions.primaryTextConditions != null &&
									<React.Fragment > ({this.returnReference()})</React.Fragment>
								}
							</span>
						))}
					</TextWithFieldname>
				}
				{process === 'summary' && this.props.teaser &&
					this.props.teaser.additionnalPrecision != null &&
					<TextWithFieldname fieldname="additionnalPrecision" variant="caption" developperView={developperView}>
						{this.props.teaser.additionnalPrecision.map(this.renderTextLine(amountNature))}
					</TextWithFieldname>
				}
				{(process === 'basket' || process === 'options' || process === 'accessories ') && this.props.teaser &&
					this.props.teaser.additionnalBasketPrecision != null &&
					<TextWithFieldname fieldname="additionnalBasketPrecision" variant="caption" developperView={developperView}>
						{this.props.teaser.additionnalBasketPrecision.map(this.renderTextLine(amountNature))}
					</TextWithFieldname>
				}
				{this.props.teaser && this.props.teaser.legalNotice != null &&
					<TextWithFieldname fieldname="legalNotice" variant="h6" developperView={developperView}>
						{Dico.getTextWithArguments(this.props.teaser.legalNotice,
							this.props.teaser.data,
							amountNature, this.props.context.countryCode, this.props.context.languageCode,
							this.props.teaser.guide)}
					</TextWithFieldname>
				}
				{this.props.teaser && this.props.teaser.financeLogo != null &&
					<TextWithFieldname fieldname="financeLogo" developperView={developperView}>
						{this.props.teaser.financeLogo.src && this.props.teaser.financeLogo.src.trim() !== '' &&
							<img src={this.props.teaser.financeLogo.src} style={{maxHeight:'200px'}} alt="" />
						}
					</TextWithFieldname>
				}
				<ResultError
					responseObject={this.props.responseObject}
					settings={this.props.settings}
					vehicle={this.props.vehicle}
				/>
			</div>
		)
	}
	returnReference() {
		const occRenvoiIni = this.occRenvoiGlob;
		this.occRenvoiGlob++;
		return occRenvoiIni;
	}
	renderTextLine(amountNature) {
		return (line, index) => (
			<span key={index} style={{ display: 'block', fontSize: '10pt' }}>
				{Dico.getTextWithArguments(line,
					this.props.teaser.data,
					amountNature, this.props.context.countryCode, this.props.context.languageCode,
					this.props.teaser.guide)}
			</span>
		);
	}
}

export default (TeaserPres)

